import { classicBusinessProjectFormSubmitEmbedRoute } from '@jira/router-routes__business-form-routes/src/classicBusinessProjectFormSubmitEmbedRoute.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { formSubmitEmbedPageEntrypoint } from './ui/form-submit-embed/index.tsx';

export const classicBusinessProjectFormSubmitEmbedRouteEntry: Route = createEntry(
	classicBusinessProjectFormSubmitEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-submit-embed-view',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: getProjectViewResources(),
		entryPoint: () => formSubmitEmbedPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
